import type {CouponForm} from '../../types';

import {EditOutlined} from '@ant-design/icons';
import {IconButton} from '@ds/components';

type CouponReviewProps = {
  form: CouponForm;
  onEditDate: () => void;
};

const formatDate = (date?: string): string => {
  if (!date) {
    return '-';
  }

  const parsedDate = new Date(date);
  const weekday = parsedDate.toLocaleDateString('fa-IR', {weekday: 'long'});
  const readableDate = parsedDate.toLocaleDateString('fa-IR', {
    month: 'long',
    day: 'numeric'
  });

  return `${weekday} ${readableDate}`;
};

const CouponReview: React.FC<CouponReviewProps> = ({form, onEditDate}) => {
  return (
    <section className="flex-1 pt-4">
      <p className="px-4 text-body-sm text-neutral-fg">
        جزئیات کوپن خود را بررسی و در صورت صحیح بودن آن را «ایجاد» کنید.
      </p>
      <div className="px-4">
        <div className="flex flex-col border-b border-gray-22 py-3">
          <span className="text-body-sm text-gray-34">هدیه</span>
          <span className="text-body-sm-emphasis text-neutral-fg">{form.coupon?.description}</span>
        </div>
        <div className="flex flex-col border-b border-gray-22 py-3">
          <span className="text-body-sm text-gray-34">شرط</span>
          <span className="text-body-sm-emphasis text-neutral-fg">{form.coupon?.title}</span>
        </div>
        <div className="flex items-center justify-between gap-3 py-3">
          <div className="flex min-w-0 flex-1 flex-col">
            <span className="text-body-sm text-gray-34">بازه زمانی</span>
            <span className="text-body-sm-emphasis text-neutral-fg">
              {formatDate(form.date.start)} تا {formatDate(form.date.end)}
            </span>
          </div>
          <IconButton aria-label="ویرایش بازه زمانی" size="md" onClick={onEditDate}>
            <EditOutlined aria-hidden />
          </IconButton>
        </div>
      </div>
    </section>
  );
};

export default CouponReview;
